import React from 'react';
import { textEncodingAtom } from 'js/file_viewer/core/atoms/ui/text';
import { usePreviewKeyAtom } from 'js/file_viewer/core/atoms/use_atom';
import { usePreviewMetadataForPreviewKey } from 'js/file_viewer/core/queries/preview_metadata';
import { useTextDataQuery } from 'js/file_viewer/core/queries/riviera_preview_types/text';
/**
 * Detects the encoding of a file based on the presence of a Byte Order Mark (BOM)
 * Supports UTF-8, UTF-16BE, and UTF-16LE encodings and defaults to UTF-8 if no BOM is found
 * https://en.wikipedia.org/wiki/Byte_order_mark
 *
 * @param {ArrayBuffer} buffer
 * @returns {string}
 */
const inferEncoding = (buffer) => {
    const dataView = new DataView(buffer);
    if (dataView.byteLength >= 2) {
        if (dataView.getUint8(0) === 0xfe && dataView.getUint8(1) === 0xff) {
            return 'utf-16be';
        }
        else if (dataView.getUint8(0) === 0xff && dataView.getUint8(1) === 0xfe) {
            return 'utf-16le';
        }
    }
    return 'utf-8';
};
export function useExtractedText(previewKey) {
    var _a;
    const previewMetadata = usePreviewMetadataForPreviewKey(previewKey);
    const fileContent = (_a = useTextDataQuery(previewKey, previewMetadata).data) === null || _a === void 0 ? void 0 : _a.apiData;
    const [stateEncoding, setStateEncoding] = usePreviewKeyAtom(textEncodingAtom, previewKey);
    const encoding = React.useMemo(() => (stateEncoding ? stateEncoding : fileContent ? inferEncoding(fileContent) : undefined), [stateEncoding, fileContent]);
    React.useEffect(() => {
        if (encoding !== undefined && stateEncoding !== encoding) {
            setStateEncoding(encoding);
        }
    }, [encoding, setStateEncoding, stateEncoding]);
    return React.useMemo(() => {
        if (!previewKey || !fileContent || encoding === undefined) {
            return undefined;
        }
        const decoder = new TextDecoder(encoding);
        return decoder.decode(fileContent);
    }, [encoding, fileContent, previewKey]);
}
//# sourceMappingURL=useExtractedText.preenvesnextjs.map
